import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth, hasAdminPanelAccess } from '../contexts/AuthContext';
import Button from '../components/Button';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { authService } from 'api/services/AuthService';
import { userService } from 'api/services/UserService';
import { CurrentUserViewModel } from 'api/types/auth/CurrentUserViewModel';
import { UserProfile } from 'types/userProfile';
import ProfileInformationForm from 'components/Profile/ProfileInformationForm';
import Navbar from 'components/Header/Navbar';
import ProfileCard from 'components/Profile/ProfileCard';

const Profil: React.FC = () => {
  // Initialize Bootstrap dropdown functionality
  // useEffect(() => {
  //   // Check if the bootstrap object is available
  //   if (typeof document !== 'undefined') {
  //     // This will run after the component mounts and the DOM is available
  //     const dropdownElementList = document.querySelectorAll('.dropdown-toggle');

  //     // Initialize each dropdown
  //     dropdownElementList.forEach(dropdownToggleEl => {
  //       // Make sure click events work properly
  //       dropdownToggleEl.addEventListener('click', function (e) {
  //         e.stopPropagation();
  //       });
  //     });
  //   }
  // }, []);

  return (
    <div className="min-vh-100" style={{ backgroundColor: 'var(--sb-bg-muted)' }}>
      {/* Header */}
      <Navbar />

      <main className="container py-4">
        <div className="row">
          <ProfileCard />

          <div className="col-md-8">

            <ProfileInformationForm />

            {/* İki Faktörlü Doğrulama */}
            <div className="card">
              <div className="card-body">
                <h5 className="card-title mb-4">İki Faktörlü Doğrulama</h5>
                <div className="form-check form-switch mb-3">
                  <input
                    className="form-check-input"
                    id="twoFactorAuth"
                    type="checkbox"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="twoFactorAuth"
                  >
                    SMS ile İki Faktörlü Doğrulamayı Etkinleştir
                  </label>
                </div>
                <div className="alert alert-info">
                  <i className="fas fa-info-circle me-2"></i>
                  SMS ile iki faktörlü doğrulama, hesabınıza her giriş yaptığınızda cep telefonunuza bir doğrulama kodu gönderilmesini sağlar. Bu kod olmadan hesabınıza erişim sağlanamaz ve hesap güvenliğiniz en üst düzeye çıkar. Aktifleştirmek için geçerli bir cep telefonu numarası eklemeniz gerekmektedir.
                </div>
                <div className="mt-3">
                  <Button className="btn btn-outline-primary" type="button">
                    <i className="fas fa-mobile-alt me-2"></i>
                    Doğrulama Kodunu Gönder
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* CSS ekleyelim */}
      <style>
        {`
        .product-card {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .product-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        }
        
        /* Dropdown Styles */
        .dropdown-menu {
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
            animation: fadeIn 0.3s ease;
        }

        .dropdown-header {
            font-weight: 600;
            letter-spacing: 0.5px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        }

        .dropdown-item {
            padding: 0.6rem 1.2rem;
            transition: all 0.2s;
        }

        .dropdown-item:hover {
            background-color: #f0f7ff;
            padding-left: 1.5rem;
        }

        .dropdown-item:active {
            background-color: #0d6efd;
            color: white;
        }

        .dropdown-item:active i {
            color: white !important;
        }

        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
        }

        /* Navbar Styles */
        .btn-link {
            text-decoration: none !important;
            box-shadow: none !important;
            border: none !important;
            outline: none !important;
        }

        .btn-link:focus, .btn-link:hover, .btn-link:active {
            text-decoration: none !important;
            box-shadow: none !important;
            border: none !important;
            outline: none !important;
        }

        .dropdown-toggle::after {
            vertical-align: middle;
            margin-left: 0.4em;
        }

        /* Profile Photo Styles */
        .profile-photo {
            position: relative;
            display: inline-block;
        }
        
        .photo-edit-icon {
            position: absolute;
            bottom: 0;
            right: 10px;
            background: #0d6efd;
            color: white;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s;
        }
        
        .photo-edit-icon:hover {
            background: #0b5ed7;
            transform: scale(1.1);
        }
        `}
      </style>

      {/* Footer */}
      <footer className="footer mt-auto py-5 border-top" style={{ backgroundColor: 'var(--sb-bg)' }}>
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-3 text-center">
              <h5 className="mb-3">Hakkımızda</h5>
              <p className="text-secondary">
                SadeceBilgisayar.com, sıfır veya İkinci el teknolojik ürünleri güvenilir bir şekilde alım veya satım yapabileceğiniz bir platformdur.
              </p>
            </div>
            <div className="col-lg-3 text-center">
              <h5 className="mb-3">Önemli Tavsiyeler</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <Link className="text-secondary text-decoration-none d-inline text-nowrap" to="/masaustu_tavsiyeler">
                    Masaüstü alırken dikkat edilmesi gerekenler
                  </Link>
                </li>
                <li className="mb-2">
                  <Link className="text-secondary text-decoration-none d-inline" to="/laptop-tavsiyeler">
                    Laptop alırken dikkat edilmesi gerekenler
                  </Link>
                </li>
                <li className="mb-2">
                  <Link className="text-secondary text-decoration-none d-inline" to="/donanim-tavsiyeler">
                    Donanım alırken dikkat edilmesi gerekenler
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 text-center">
              <h5 className="mb-3">İletişim</h5>
              <div className="contact-info">
                <p className="text-secondary mb-2">Görüşleriniz ve şikayetleriniz için</p>
                <p className="text-secondary mb-2">
                  <i className="fas fa-envelope me-2"></i>
                  info@sadecebilgisayar.com
                </p>
              </div>
            </div>
            <div className="col-lg-3 text-center">
              <h5 className="mb-3">Sosyal Medya Hesaplarımız</h5>
              <div className="social-links">
                <a className="text-primary me-4" href="#">
                  <i className="fab fa-facebook fa-3x"></i>
                </a>
                <a className="text-danger me-4" href="#">
                  <i className="fab fa-instagram fa-3x"></i>
                </a>
                <a className="text-danger" href="#">
                  <i className="fab fa-youtube fa-3x"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="footer-bottom mt-5 pt-4 border-top">
            <div className="row">
              <div className="col-md-6">
                <p className="text-secondary mb-0">© 2024 SadeceBilgisayar.com - Tüm hakları saklıdır.</p>
              </div>
              <div className="col-md-6 text-md-end">
                <Link className="text-secondary me-3" to="/gizlilik-politikasi">Gizlilik Politikası</Link>
                <Link className="text-secondary me-3" to="/kullanici-sozlesmesi">Kullanım Koşulları</Link>
                <Link className="text-secondary" to="/cerez-politikasi">Çerez Politikası</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Profil;
